<template>
  <div
    :class="$style['promotion']"
    @click="onClick">
    <div
      :class="
        $style['promotion__background']
      " />

    <VideoPlayer :class="$style['promotion__video']" src="https://vz-df3f7e0c-f41.b-cdn.net/8b974e5c-c4ca-4dfd-807d-af4840dcee95/playlist.m3u8" />
  </div>
</template>
<script>
import baseScript from './Shared/script'
export default {
  extends: baseScript
}
</script>
<style lang="scss" module>
@use './Shared/style';

.promotion {
  position: relative;

  &__background {
    position: absolute;
    width: 100.5%;
    aspect-ratio: 16 / 13;
    background-size: cover;
    background-image: url('/images/promotions/big-party.webp');
  }

  &__video {
    position: absolute;
    aspect-ratio: 16 / 13;
    width: 100%;
    height: 100%;
    z-index: 1;
  }
}
</style>
